import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=2cd44a9c&scoped=true&"
import script from "./changePwd.vue?vue&type=script&lang=ts&"
export * from "./changePwd.vue?vue&type=script&lang=ts&"
import style0 from "./changePwd.vue?vue&type=style&index=0&id=2cd44a9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd44a9c",
  null
  
)

export default component.exports